import React from "react";
import { Row } from "antd";
// import { NavLink } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Div } from "./header-search-style";
// import { headerSearchAction } from "../../redux/headerSearch/actionCreator";

const HeaderSearch = ({ darkMode }) => {
  return (
    <>
      <Div
        className="certain-category-search-wrapper"
        style={{ width: "100%" }}
        darkMode={darkMode}>
        <Row className="ant-row-middle">
          {/* <Col md={2} xs={1} className={rtl ? 'text-left' : 'text-right'}>
            <span className="certain-category-icon">
              <FeatherIcon icon="search" size={16} />
            </span>
          </Col>
          <Col md={22} xs={23}>
            <Popover
              placement={!rtl ? 'bottomLeft' : 'bottomRight'}
              content={content}
              title="Search List"
              action="focus"
            >
              <Input placeholder="Search..." onInput={search} />
            </Popover>
          </Col> */}
        </Row>
      </Div>
    </>
  );
};

HeaderSearch.propTypes = {
  darkMode: PropTypes.bool
};

export default HeaderSearch;
